import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useTranslation } from '../../../../hooks/useTranslation';
import { ValidatedSingleDateRangeValueInputProps } from '../types';

export const DateRangeSelect = ({
  onChange,
  value,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
}: ValidatedSingleDateRangeValueInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueDateRangeSelect: VisualComponent } = useVisualComponentsContext();

  return (
    <VisualComponent
      comparator={comparator}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      hasError={!!isInvalid}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={!!isReadOnly}
      onChange={onChange}
      value={value}
      placeholder={t('v2.conditionBuilder.singleDateRangePlaceholder')}
    />
  );
};
